import { faTeeth } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@repo/videa-components/src/index';

import { type TDisplayOrderQuadrantAbbreviations } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';
import type { TVisitSummary } from '@/react-query/useVisitSummaries';
import type { SeverityLabel } from '@/utils/hooks/useRblSeverities';
import { useUniversalToFDI } from '@/utils/internationalization/useUniversalToFDI';

import type { ImageObject } from '../types';

import { getToothHasBoneLevelMeasurements } from './helpers';
import { SeverityTag } from './SeverityTag';
import { ToothBoneLevels } from './ToothBoneLevels';

interface Props {
  quadrant: TDisplayOrderQuadrantAbbreviations;
  quadrantTeeth: TVisitSummary['teeth'];
  severity?: SeverityLabel | null;
  activeImage?: ImageObject;
}

export const BoneLevelAccordionItem = ({
  quadrant,
  quadrantTeeth,
  severity,
  activeImage,
}: Props) => {
  const { displayLocalizedQuadrantLongName } = useUniversalToFDI();

  const hasBoneLevelMeasurements = quadrantTeeth.some((tooth) =>
    getToothHasBoneLevelMeasurements(tooth),
  );

  if (!hasBoneLevelMeasurements) return null;

  return (
    <AccordionItem value={quadrant}>
      <AccordionTrigger
        className="!vai-py-2 [@media(max-height:570px)]:!vai-py-1"
        data-testid={`bone-level-accordion-${quadrant}`}
      >
        <div className="vai-flex vai-items-center vai-gap-2">
          <FontAwesomeIcon icon={faTeeth} />
          <p className="vai-mr-2 vai-typography-small vai-text-white">
            {displayLocalizedQuadrantLongName(quadrant)}
          </p>
          <SeverityTag severity={severity} />
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <div className="vai-flex vai-flex-col vai-gap-2">
          {quadrantTeeth.map((tooth) => (
            <ToothBoneLevels
              key={tooth.toothId}
              tooth={tooth}
              activeImage={activeImage}
            />
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
